import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';
import packageJson from '../../../package.json';


export function* initManagedSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  yield put(actions.initManagedStart());
  try {
    let response = {};

    // if(1===1){//COMMENT OUT IF TESTING SERVER


        //COMMENT IN IF TESTING SERVER
      const token = yield sessionStorage.getItem('token');
      const sessionToken = yield sessionStorage.getItem('sessionToken');
      if (sessionToken) {
        response = yield axios.post(
          '/managed',
          { rMac:rMac,
            bToken: token,
            sessionToken:sessionToken }
        ).then(res=>{
          return JSON.parse(res.data.managed)

        })
        ///////////////


    } else {
      // console.log('NO TOKEN')
     }
    yield put(actions.setManaged(response));//COMMENT THIS IN IF TESTING SERVER
  } catch (error) {
    yield put(actions.fetchManagedFailed());
  }

}



